import React from "react";
import {isEditableMode, useFormMode} from "@contexts/FormModeContext";

export default function AddItemButtonComponent(
    {
        text = 'Add Item',
        onClick,
        hideText = false
    }
) {
   
   const {mode} = useFormMode();
   
   if(!isEditableMode(mode)) {
      return null;
   }
   
    if(typeof text !== "string" || text.trim() === '') {
        text = 'Add Item';
    }

    return (
        <button
            type="button"
            className="btn btn-primary"
            onClick={onClick}
        >
            <i className="fa fa-plus"/> {!hideText && text}
        </button>
    );

}